import React from 'react';
import { motion } from 'framer-motion';

const LeadingTheWaySection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 25 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 overflow-hidden select-none text-left">
      <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-start w-full"
        >

          <motion.div
            variants={itemVariants}
            className="lg:col-span-4 flex flex-col items-start w-full pr-0 lg:pr-6"
          >
            <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight leading-tight mb-5 font-sora">
              Leading the Way
            </h2>
            <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik">
              We are leading the way by leveraging technology that our customers to monitor, measure, improve, and achieve the desired business outcomes sustainably.
            </p>
          </motion.div>

          <motion.div
            variants={itemVariants}
            className="lg:col-span-8 w-full bg-white border border-[#01386A45] p-6 sm:p-[30px] flex flex-col md:flex-row items-center gap-[30px] lg:gap-[60px] relative rounded-none group shadow-[0_10px_30px_rgba(0,0,0,0.01)] min-h-[340px]"
          >
            <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-10" />

            <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#EA580C] z-20 transition-all duration-500 ease-out group-hover:w-full" />

            <div className="w-full md:w-[40%] max-w-[233px] overflow-hidden bg-[#030c22] shrink-0 relative z-30">
              <img
                src="/assets/sustainability/img3.png"
                alt="Digital global matrix networking grid graphic structure"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>

            <div className="flex-1 flex flex-col items-start relative z-30">
              <h3 className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight leading-snug mb-4 transition-colors duration-300">
                Sustainability (ESG) Offerings
              </h3>
              <p className="text-[#49577A] text-[14px] sm:text-[16px] leading-relaxed font-[500] font-graphik">
                Our sustainable solutions, driven by new-age technologies and decades of experience, help transform your business model into a greener, better organization.
              </p>
            </div>
          </motion.div>

        </motion.div>

      </div>
    </section>
  );
};

export default LeadingTheWaySection;